import { Guid, isNotNil, Nillable } from '@web/utils';
import { isImageType } from '../../shared/api/helpers/is-image-type';
import { MultimediaType } from '../../shared/enums/multimedia-type';
import { isArchiveType, isDocumentType } from '../../shared/api/helpers';

export class AdminMultimediaDetails {
  public constructor(
    private readonly data: {
      alt: string;
      canBeEdited: boolean;
      canBeRemoved: boolean;
      createdAt: Date;
      description?: Nillable<string>;
      extension: string;
      filename: string;
      height?: Nillable<number>;
      id: Guid;
      mimeType: string;
      previewUrl: string;
      downloadUrl: string;
      size: number;
      thumbnailPreviewUrl: string;
      type: MultimediaType;
      width?: Nillable<number>;
    },
  ) {}

  public get isImage(): boolean {
    return isImageType(this.data.type);
  }

  public get isDocument(): boolean {
    return isDocumentType(this.data.type);
  }

  public get isArchive(): boolean {
    return isArchiveType(this.data.type);
  }

  public get dimensions(): Nillable<string> {
    return isNotNil(this.data.width) && isNotNil(this.data.height)
      ? `${this.data.width} x ${this.data.height}`
      : null;
  }

  public get id(): Guid {
    return this.data.id;
  }

  public get filename(): string {
    return this.data.filename;
  }

  public get thumbnailPreviewUrl(): string {
    return this.data.thumbnailPreviewUrl;
  }

  public get previewUrl(): string {
    return this.data.previewUrl;
  }

  public get extension(): string {
    return this.data.extension;
  }

  public get mimeType(): string {
    return this.data.mimeType;
  }

  public get size(): number {
    return this.data.size;
  }

  public get createdAt(): Date {
    return this.data.createdAt;
  }

  public get alt(): string {
    return this.data.alt;
  }

  public get type(): MultimediaType {
    return this.data.type;
  }

  public get width(): Nillable<number> {
    return this.data.width;
  }

  public get height(): Nillable<number> {
    return this.data.height;
  }

  public get description(): Nillable<string> | undefined {
    return this.data.description;
  }

  public get canBeEdited(): boolean {
    return this.data.canBeEdited;
  }

  public get canBeRemoved(): boolean {
    return this.data.canBeRemoved;
  }

  public get downloadUrl(): string {
    return this.data.downloadUrl;
  }
}
